import { render } from "./GDimakis.vue?vue&type=template&id=59864d1d"
import script from "./GDimakis.vue?vue&type=script&lang=js"
export * from "./GDimakis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__